import { post } from './base';

const URL = '/application';

export const PostTourRequestAPI = payload =>
  post(`${URL}/new-tour-request/`, payload);
export const PostSpaceRentalAPI = payload =>
  post(`${URL}/space-rental-v2/`, payload);
export const PostRentSpaceAPI = payload => post(`${URL}/rent-space/`, payload);
export const PostPartnerShipAPI = payload =>
  post(`${URL}/partnership/`, payload);
export const PostDevelopmentAPI = payload =>
  post(`${URL}/development/`, payload);
